import React, { useState } from "react";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import Checkbox from "@mui/material/Checkbox";

import {
  UserConfigCameraSettings,
  SingleCameraSettings,
} from "../../../../../util/model";
import "./CameraSettings.scss";

interface Props {
  config: UserConfigCameraSettings;
  onCurrentCameraChange: (val: string) => void;
  onCamerasChange: (val: SingleCameraSettings[]) => void;
}

export default function CameraSettings(props: Props) {
  const [cameraName, setCameraName] = useState(props.config.CurrentCamera);
  const [targetLat, setTargetLat] = useState("");
  const [targetLon, setTargetLon] = useState("");
  const [cameraH, setCameraH] = useState("");

  function onCameraNameChange(val: any) {
    setCameraName(val.target.value);
  }

  function onTargetLatChange(val: any) {
    setTargetLat(val.target.value);
  }

  function onTargetLonChange(val: any) {
    setTargetLon(val.target.value);
  }

  function onCameraHChange(val: any) {
    setCameraH(val.target.value);
  }

  function onCameraUpdateClick() {
    var Lat = +targetLat;
    if (Lat < -90) {
      Lat = -90;
    }
    if (Lat > 90) {
      Lat = 90;
    }
    var Lon = +targetLon;
    if (Lon < -180) {
      Lon = -180;
    }
    if (Lon > 180) {
      Lon = 180;
    }
    var H = +cameraH;
    if (H < 0) {
      H = 0;
    }
    if (H > 1000000) {
      H = 1000000;
    }
    var Index = -1;
    for (var i = 0; i < props.config.Cameras.length; ++i) {
      if (props.config.Cameras[i].Name == cameraName) {
        Index = i;
      }
    }
    if (Index >= 0) {
      props.config.Cameras[Index].CameraPos = [Lon, Lat, H];
      props.config.Cameras[Index].TargetPos = [Lon, Lat, 0];
    } else {
      var Camera = {
        Name: cameraName,
        CameraPos: [Lon, Lat, H],
        TargetPos: [Lon, Lat, 0],
      };
      props.config.Cameras.push(Camera);
    }
    props.onCamerasChange(props.config.Cameras);
  }

  function onCameraSelectClick(val: any, index: number) {
    props.config.CurrentCamera = props.config.Cameras[index].Name;
    setCameraName(props.config.CurrentCamera);
    setTargetLon(props.config.Cameras[index].TargetPos[0].toString());
    setTargetLat(props.config.Cameras[index].TargetPos[1].toString());
    setCameraH(props.config.Cameras[index].CameraPos[2].toString());
    props.onCurrentCameraChange(props.config.CurrentCamera);
  }

  function onCameraDeleteClick(val: any, index: number) {
    props.config.Cameras.splice(index, 1);
    props.onCamerasChange(props.config.Cameras);
  }

  return (
    <div className="CameraSettings">
      <FormControl className="form-item">
        <TextField
          id="camera-settings-source-id"
          label="Camera Name"
          type="string"
          value={cameraName}
          onChange={onCameraNameChange}
        />
      </FormControl>
      <Table>
        <TableBody>
          <TableRow>
            <TableCell style={{ width: "33%" }}>
              <FormControl className="form-item">
                <TextField
                  id="camera-settings-target-lat"
                  label="Lat (deg) (-90 - 90)"
                  type="string"
                  value={targetLat}
                  onChange={onTargetLatChange}
                  InputLabelProps={{ style: { fontSize: 12 } }}
                />
              </FormControl>
            </TableCell>
            <TableCell style={{ width: "33%" }}>
              <FormControl className="form-item">
                <TextField
                  id="camera-settings-target-lon"
                  label="Lon (deg) (-180 - 180)"
                  type="string"
                  value={targetLon}
                  onChange={onTargetLonChange}
                  InputLabelProps={{ style: { fontSize: 12 } }}
                />
              </FormControl>
            </TableCell>
            <TableCell style={{ width: "33%" }}>
              <FormControl className="form-item">
                <TextField
                  id="camera-settings-camera-h"
                  label="H (m) (0 - 1000000)"
                  type="string"
                  value={cameraH}
                  onChange={onCameraHChange}
                  InputLabelProps={{ style: { fontSize: 12 } }}
                />
              </FormControl>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
      <FormControl className="form-item">
        <Button
          color="secondary"
          variant="contained"
          onClick={onCameraUpdateClick}
        >
          UPDATE CAMERA
        </Button>
      </FormControl>
      <Table className="CameraTable_name">
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Delete</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.config.Cameras.map((camera, index) => (
            <TableRow>
              <TableCell onClick={(e) => onCameraSelectClick(e, index)}>
                {camera.Name}
              </TableCell>
              <TableCell>
                <IconButton
                  size="small"
                  onClick={(e) => onCameraDeleteClick(e, index)}
                >
                  <DeleteIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
